import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { GET_MISSIONS } from './get-missions';
import type { PostMissionParams } from '../types';
import { queryClient } from '@/_config/lib/react-query/query-client';

const buildMissionFormData = (params: PostMissionParams) => {
  const formData = new FormData();

  formData.append('startDate', params.startDate.toISOString());
  formData.append('endDate', params.endDate.toISOString());
  formData.append('type', params.type);
  formData.append('cityIds', JSON.stringify(params.cityIds));
  formData.append('deliverymanIds', JSON.stringify(params.deliverymanIds));
  formData.append('name', params.name);
  formData.append('budget', String(params.budget));
  formData.append('rewardLevels', JSON.stringify(params.rewardLevels));
  formData.append('title', params.title);
  formData.append('description', params.description);
  formData.append('managerId', params.managerId);

  if (params.idsDocument) {
    formData.append('idsDocument', params.idsDocument, params.idsDocument.name);
  }

  return formData;
};

const postMission = async (params: PostMissionParams) =>
  apiClient
    .post('/missions', buildMissionFormData(params), {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response =>
      handleResponseSuccess(response, 'Missão criada com sucesso!')(),
    )
    .catch(handleResponseThrowError('Não foi possível criar a missão.'));

export const usePostMission = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PostMissionParams> = {}) => {
  return useMutation({
    mutationFn: postMission,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([GET_MISSIONS], { exact: false });
      onSuccess?.(...args);
    },
    ...options,
  });
};
